var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.069 7.47166C16.0048 7.46249 15.9406 7.46249 15.8765 7.47166C14.4556 7.42583 13.3281 6.26166 13.3281 4.83166C13.3281 3.37416 14.5106 2.1825 15.9773 2.1825C17.4348 2.1825 18.6265 3.36499 18.6265 4.83166C18.6173 6.26166 17.4898 7.42583 16.069 7.47166Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.0576 13.8242C18.031 14.5117 16.5918 14.7684 15.2626 14.5942C15.611 13.8425 15.7943 13.0084 15.8035 12.1284C15.8035 11.2117 15.6018 10.3409 15.2168 9.58002C16.5735 9.39669 18.0126 9.65335 19.0485 10.3409C20.4968 11.2942 20.4968 12.8617 19.0576 13.8242Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.9038 7.47166C5.96797 7.46249 6.03214 7.46249 6.0963 7.47166C7.51714 7.42583 8.64464 6.26166 8.64464 4.83166C8.64464 3.36499 7.46214 2.1825 5.99547 2.1825C4.53797 2.1825 3.35547 3.36499 3.35547 4.83166C3.35547 6.26166 4.48297 7.42583 5.9038 7.47166Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.00452 12.1283C6.00452 13.0175 6.19702 13.8608 6.54535 14.6217C5.25285 14.7592 3.90535 14.4842 2.91535 13.8333C1.46702 12.8708 1.46702 11.3033 2.91535 10.3408C3.89618 9.68084 5.28035 9.41501 6.58202 9.56168C6.20618 10.3317 6.00452 11.2025 6.00452 12.1283Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.1104 14.8967C11.0371 14.8875 10.9546 14.8875 10.8721 14.8967C9.18539 14.8417 7.83789 13.4575 7.83789 11.7525C7.84706 10.0108 9.24956 8.59918 11.0004 8.59918C12.7421 8.59918 14.1537 10.0108 14.1537 11.7525C14.1446 13.4575 12.8062 14.8417 11.1104 14.8967Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.1309 16.7942C6.74673 17.72 6.74673 19.2417 8.1309 20.1584C9.70757 21.2125 12.2926 21.2125 13.8692 20.1584C15.2534 19.2325 15.2534 17.7109 13.8692 16.7942C12.3017 15.74 9.71673 15.74 8.1309 16.7942Z",
    fill: "#FCFCFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/forum.16875906ebce1d2dc38d4c7f94ced77d.svg";
export { ForwardRef as ReactComponent };